<script setup>
import { computed } from "vue";
import { cn } from "@/shared/lib/utils";

const props = defineProps({
  class: { type: String, default: "" },
});

const classes = computed(() =>
  cn(
    "pointer-events-none inline-flex h-5 select-none items-center gap-1 rounded border bg-muted px-1.5 font-mono text-[10px] font-medium text-muted-foreground opacity-100",
    props.class
  )
);
</script>

<template>
  <kbd :class="classes">
    <slot />
  </kbd>
</template>
